import { Edit2, Eye, Trash2, Users, Clock, CheckCircle, XCircle, AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '../../ui/button';

const STATUS_COLORS = {
  draft: 'bg-gray-500/20 text-gray-400',
  scheduled: 'bg-yellow-500/20 text-yellow-400',
  sending: 'bg-blue-500/20 text-blue-400',
  sent: 'bg-green-500/20 text-green-400',
  failed: 'bg-red-500/20 text-red-400',
};

const STATUS_ICONS = {
  draft: Edit2,
  scheduled: Clock,
  sending: RefreshCw,
  sent: CheckCircle,
  failed: XCircle,
};

const AUDIENCE_LABELS = {
  all: 'All Fans',
  premium: 'Premium Subscribers',
  purchasers: 'Previous Buyers',
  engaged: 'Engaged Fans',
  inactive: 'Inactive Users',
  subscribers: 'Newsletter Subscribers',
};

export function CampaignCard({ campaign, onEdit, onPreview, onDelete }) {
  const StatusIcon = STATUS_ICONS[campaign.status] || AlertCircle;
  
  return (
    <div 
      className="bg-white/5 border border-white/10 rounded-xl p-5 hover:border-white/20 transition-all"
      data-testid={`campaign-card-${campaign.id}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="font-semibold text-lg">{campaign.name}</h3>
            <span className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${STATUS_COLORS[campaign.status]}`}>
              <StatusIcon className="w-3 h-3" />
              {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
            </span>
          </div>
          <p className="text-gray-400 text-sm mb-2">Subject: {campaign.subject}</p>
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <span className="flex items-center gap-1">
              <Users className="w-4 h-4" />
              {AUDIENCE_LABELS[campaign.audience_type] || campaign.audience_type}
            </span>
            {campaign.sent_at && (
              <span>Sent: {new Date(campaign.sent_at).toLocaleDateString()}</span>
            )}
            {campaign.stats?.sent > 0 && (
              <span className="text-green-400">{campaign.stats.sent} delivered</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {campaign.status === 'draft' && (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onEdit(campaign)}
                data-testid={`edit-campaign-${campaign.id}`}
              >
                <Edit2 className="w-4 h-4" />
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onPreview(campaign)}
                data-testid={`preview-campaign-${campaign.id}`}
              >
                <Eye className="w-4 h-4" />
              </Button>
            </>
          )}
          {campaign.status === 'sent' && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onPreview(campaign)}
            >
              <Eye className="w-4 h-4" />
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            className="text-red-400 hover:text-red-300"
            onClick={() => onDelete(campaign.id)}
            data-testid={`delete-campaign-${campaign.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
